import { Component, OnInit, OnDestroy, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {FileService} from "../../../_services/file.service";
import {DialogPdfComponent} from '../../profile/dialog-pdf/dialog.component';

@Component({
  selector: 'pdf-upload-component',
  templateUrl: './pdf.upload.component.html',
  providers:[FileService]
})
export class PDFUploadComponent implements OnInit, OnDestroy {
  @ViewChild('droppable1') droppable1: ElementRef;
  @ViewChild('droppable2') droppable2: ElementRef;

  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() jsclassinit:any;
  @Input() questioninitmixin:any;
  @Input() value:any;
  @Input() disabled:boolean;
  @Input() required:boolean;

  validationMessages: any;
  formErrors:any;
  formSegment:FormGroup;
  subscriptions:any;
  filepath:string;
  filename:string;
  touched:boolean=false;

  public getValue(){
    var v,value={},result={};
    if(!this.disabled) {
      if(!!this.filepath) {
        result['filepath']=this.filepath;
      }
      if(!!this.filename) {
        result['filename']=this.filename;
      }
      v=this.formSegment.value;
      if(!!v && !!v.fileId) {
        result['fileId']=v.fileId;
      }
      if(!!this.questioninitmixin && !!this.questioninitmixin.attachableType) {
        result['attachableType']=this.questioninitmixin.attachableType;
      }
    }
    value[this.questionid]=result;
    return value;
  }

  constructor(
    private _fileService:FileService,
    public dialog: MatDialog
  ) {
    this.subscriptions=[];
  }

  isValid():boolean {
    if(this.required) {
      return !!this.filepath;
    }
    return true;
  }
  validate():boolean {
    this.touched=true;
    return this.isValid();
  }

  onDrop(files, evt, classobject?: any) {
      classobject.touched=true;
      classobject.loading = true;
      for (let i = 0; i < files.length; i++) {
          let ext = '';
          //console.log(files[i]);
          // Here, we simply log the Array of files to the console.
          let mimeType = files[i].type;
          ext = files[i].name.split('.').pop();
          //console.log(ext);
          const allowedMIMEType = ['application/pdf','image/jpeg','image/x-png','image/png'];
          if(allowedMIMEType.indexOf(mimeType)>= 0 ){
              classobject.filetype = ext;

              const body = {
                  attachableId: '',
                  file: files[i],
                  attachableType:classobject.questioninitmixin.attachableType
              };

              //console.log(body);

              classobject.subscriptions.push(classobject._fileService.uploadFile(body).subscribe(

                responsedata => {
                  var parsed=JSON.parse(responsedata._body);
                  //console.log(responsedata);
                  let fileId = parsed.data.fileId;
                  classobject.formSegment.controls["fileId"].setValue(fileId);

                  classobject.filename = files[i].name;

                  let filelink = parsed.data.filelink;
                  classobject.filepath = filelink;

                  classobject.loading = false;
                },

                error => {
                  classobject.loading = false;
                }

              ));

          } else {
              alert("File not allowed");
              classobject.loading = false;
          }
      }
  }

  changePdf(filepath) {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: filepath }
    });
  }

  makeDroppable(element, callback,classObj) {
    var input = document.createElement('input');
    input.setAttribute('type', 'file');
    //input.setAttribute('multiple', 'true');
    input.style.display = 'none';

    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);

    element.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
      triggerCallback(e,classObj);
    });

    element.addEventListener('click', function() {
      input.value = null;
      input.click();
      //console.log(input);
    });

    function triggerCallback(e,obj) {
      var files;
      if(e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if(e.target) {
        files = e.target.files;
      }
      callback.call(null,files,e,obj);
    }
  }

  ngOnInit() {
    var init={};
    init['fileId']=new FormControl();
    this.formSegment=new FormGroup(init);

    this.makeDroppable(this.droppable1.nativeElement, this.onDrop, this);
    this.makeDroppable(this.droppable2.nativeElement, this.onDrop, this);

    if(!!this.value) {
      if(!!this.value.filename) {
        this.filename=this.value.filename;
      }
      if(!!this.value.filepath) {
        this.filepath=this.value.filepath;
      }
      if(!!this.value.fileId) {
        init['fileId'].setValue(this.value.fileId);
      }
    }
  }

  ngOnDestroy() {
    var C;
    while(C=this.subscriptions.pop()) {
      C.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/pdf.upload.component.ts